import { render, staticRenderFns } from "./You.vue?vue&type=template&id=49143d6a&scoped=true&"
import script from "./You.vue?vue&type=script&lang=js&"
export * from "./You.vue?vue&type=script&lang=js&"
import style0 from "./You.vue?vue&type=style&index=0&id=49143d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49143d6a",
  null
  
)

export default component.exports